import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogramarchived/kae/";

export default class KAEApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getKAEs(params) {
    return await request.post(`${rootRoute}getKAEs`, {
      filter: params,
      parameters: {},
    });
  }
  async getKAE(id) {
    return await request.post(`${rootRoute}getKAEs`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createKAE(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createKAE`, { data });
  }
  async deleteKAE(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteKAE`, { data });
  }
  async editKAE(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateKAE`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importKAE`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getKAEimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportKAE`, {
      filter: filter,
      format: format
    });
  }
}
